<template>
  <div class="navbar-collapse collapse justify-content-end" id="navbar">
    <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
      <li class="nav-item">
        <Link
          :class="['nav-link', $page.url === '/' ? 'active' : '']"
          aria-current="page"
          :href="$route('company.dashboard')"
        >
          Inicio
        </Link>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          aria-current="page"
          href="https://adsbolsadetrabajo.laprensagrafica.com"
        >
          Anuncios LA PRENSA GRAFICA
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link btn btn-primary" aria-current="page" @click="logout">
          Salir
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
export default {
  name: 'NavBarAuthenticatedEmpresas',
  components: { Link },
  methods: {
    logout() {
      this.$inertia.delete(this.$route('company.logout'))
    },
  },
}
</script>
